import { Injectable } from "@angular/core";
import { FilterOptions } from "../models/filterOptions";

@Injectable({
    providedIn: 'root'
  })
  
  export class UrlService {

  setUrlDefault(queryString: any, filterValue: string) {
    if(decodeURI(queryString.toString()).indexOf(filterValue.replace(":", "=").replaceAll(" ", "+")) > -1) {
      queryString = decodeURI(queryString.toString()).replace(filterValue.replace(":", "=").replaceAll(" ", "+"), "");
    } else {
      queryString.append(filterValue.split(":")[0], filterValue.split(":")[1]);  
    }
    return queryString;
  }

  setUrlSearch(queryString: any, filterValue: string){
    queryString.delete(filterValue.split(":")[0]);
    if(filterValue.split(":")[1] !== ""){
      queryString.append(filterValue.split(":")[0], filterValue.split(":")[1]);  
    }
    return queryString;
  }

  getUrlParams() : FilterOptions[] {
    let params: FilterOptions[] = [];
    let search = new URLSearchParams(location.search);
    search.forEach(function(value, key) {
      params.push({
          type: key,
          value: value
      });
    });
    return params;
  }

  appendUrl(filterValue: string){
    let url = new URL(window.location.href);
    let queryString = url.searchParams;
    
    if(filterValue.split(":")[0] === "search"){
      queryString = this.setUrlSearch(queryString, filterValue);
    } else {
      queryString = this.setUrlDefault(queryString, filterValue);
    }
    url.search = queryString.toString();
    let new_url = url.toString();
    window.history.pushState({}, '', new_url);
    this.setSessionStorage(url.search);
  }

  setSessionStorage(filterValue: string){
    sessionStorage.setItem("Filter", filterValue);
  }
  getSessionStorageFilterParams(){
    let filters: FilterOptions[] = [];
    let storageFilter = new URLSearchParams(sessionStorage.getItem("Filter") ?? []);
    storageFilter.forEach(function(value, key) {
      filters.push({
          type: key,
          value: value
      });
    });
    let urlFilter = this.getUrlParams();
    urlFilter.forEach((filterItem: FilterOptions) => {
      if(filters.findIndex(s => s.value === filterItem.value) === -1 ) {
        filters.push(filterItem);
      }
    });
    
    return filters;
  }
}